<div class="layout-topbar custom-megamenu">
  <!-- Logo -->
  <div class="topbar-start">
    <a [routerLink]="'/'"><img src="/assets/images/logo/new_logo.png" alt="Craftly" class="topbar-logo" /></a>
  </div>
  
  <!-- Desktop Menu -->
  <div class="topbar-menu desktop-menu">
    <button pButton 
        type="button" 
        label="Discover templates" 
        class="gradient-button" 
        [routerLink]="'/discover'">
    </button>
    <span *ngFor="let item of items" class="menu-item-root" [routerLink]="item.url">{{ item.label }}</span>
  </div>
  
  <!-- Mobile Menu Toggle -->
  <button class="mobile-menu-toggle" (click)="toggleMobileMenu()" [attr.aria-expanded]="mobileMenuOpen">
    <i class="pi pi-bars" *ngIf="!mobileMenuOpen"></i>
    <i class="pi pi-times" *ngIf="mobileMenuOpen"></i>
  </button>

</div>

<!-- Mobile Menu Overlay -->
<div class="mobile-menu-overlay" [class.active]="mobileMenuOpen" (click)="closeMobileMenu()"></div>

<!-- Mobile Menu -->
<div class="mobile-menu" [class.active]="mobileMenuOpen">
  <div class="mobile-menu-items">
    <button pButton 
        type="button" 
        label="Discover" 
        class="gradient-button" 
        [routerLink]="'/discover'">
    </button>

    <a *ngFor="let item of items" class="mobile-menu-item" (click)="closeMobileMenu()" [routerLink]="item.url">
      {{ item.label }}
    </a>
  </div>
  <div class="mobile-menu-button">
    <!-- <p-button [rounded]="true" [label]="'Button'" [outlined]="false" class="custom-button mobile-button"></p-button> -->
  </div>
</div>
